import { Link, useNavigate } from "react-router-dom";
import { edit_icon } from "../../../icons/edit";
import { delete_icon } from "../../../icons/trash";
import empty_box from "../../../images/empty_box.png";
import { useAuth } from "../../../store/authProvider";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Client from "../../../utils/client";
import {
  getMe,
  getServicesFavorites,
} from "../../../api";
import DeleteModal from "./deleteModal";
import { exit_icon } from "../../../icons/exit";
import { EmptyStarIcon, FullStarIcon } from "../../../icons/star";
import { circle_add } from "../../../icons/circle_add";
import ContactModal from "../../../components/contact_modal";
import Skelton from "../../../icons/skelton";


function ServicesInputs() {
  const { isAuth } = useAuth();
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showServiceContactModal, setShowServiceContactModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const navigator = useNavigate();
  const {
    data: myOffers,
    isFetching: servicesFetching,
    refetch,
  } = useQuery({
    queryKey: ["my_offers"],
    queryFn: () => getMe(),
    initialData: [],
  });

  const { data: servicesFavorites } = useQuery({
    queryKey: ["services"],
    queryFn: () => getServicesFavorites(),
    initialData: [],
  });
  const [service, setService] = useState();
  const [item, setItem] = useState();

  const getService = async (id) => {
    const response = await Client.get(`/services/single/${id}`).then(
      (res) => res.data
    );
    setService(response);
    setShowServiceModal(true);
  };
  if (servicesFetching) {
    return (
      <div
        dir="rtl"
        className="my-16 grid grid-cols-1 gap-4 px-0 lg:grid-cols-5 lg:mr-8"
      >
        {[...Array(5).keys()].map((e, i) => (
          <Skelton key={i} />
        ))}
      </div>
    );
  }
  return (
    <div className="my-10 px-5 lg:px-7">
      <h1 className="text-end font-bold  text-[24px] my-10">الخدمات</h1>
      {detailsModal && (
        <DeleteModal
          setShowDetails={setDetailsModal}
          item={item}
          refetch={refetch}
        />
      )}
      <div>
        {showServiceModal ? (
          <>
            <div className="fixed inset-0 z-[10000] flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
              <div className="relative max-w-3xl w-[350px] mx-auto my-6">
                {/*content*/}
                <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none">
                  {/*header*/}
                  <div className="flex items-center justify-center p-5 rounded-t border-slate-200 ">
                    <div className="w-full flex items-center justify-between">
                      <div
                        className="text-red-600 w-8"
                        onClick={() => setShowServiceModal(false)}
                      >
                        {exit_icon}
                      </div>

                      <div className="text-gray-500 w-8">
                        {servicesFavorites.map((e) => e.id).includes(service.id)
                          ? FullStarIcon
                          : EmptyStarIcon}
                      </div>
                    </div>
                  </div>
                  {/*body*/}
                  <div className="flex justify-center h-[126px] bg-center bg-no-repeat bg-flipped-logo ">
                    <img
                      src={service.service.image}
                      className=" h-[100px]  self-center "
                      alt=""
                    />
                  </div>
                  <div className="w-full flex justify-center items-center font-bold mt-4 text-lg">
                    {service.service.name}
                  </div>
                  <div className="relative font-bold flex-auto px-4 border-2 my-4 mx-4 rounded-lg">
                    <div className="flex flex-col gap-4 py-3" dir="rtl">
                      {service.description && (
                        <ModalTable
                          description="الوصف "
                          value={service.description}
                        />
                      )}

                      <ModalTable
                        description="الموقع "
                        value={service._state.name + " - " + service._city.name}
                      />

                      {service.price_per_day !== null && (
                        <ModalTable
                          description="نوع العمالة "
                          value={service.price_per_day}
                        />
                      )}

                      {service.number_of_workers !== null && (
                        <ModalTable
                          description="عدد العمال  "
                          value={service.number_of_workers}
                        />
                      )}

                      {service.quantity !== null && (
                        <ModalTable
                          description="الكمية  "
                          value={service.quantity}
                        />
                      )}

                      {service.type !== null && (
                        <ModalTable
                          description="النوع  "
                          value={service.type}
                        />
                      )}

                      {service.payload !== null && (
                        <ModalTable
                          description="الحمولة  "
                          value={service.payload}
                        />
                      )}

                      {service.line !== null && (
                        <ModalTable description="الخط " value={service.line} />
                      )}

                      {service.temperature !== null && (
                        <ModalTable
                          description="درجة الحرارة  "
                          value={service.temperature}
                        />
                      )}
                      {service.height !== null && (
                        <ModalTable
                          description="الإرتفاع "
                          value={service.height}
                        />
                      )}

                      {service.space !== null && (
                        <ModalTable
                          description="المساحة  "
                          value={service.space}
                        />
                      )}
                    </div>
                  </div>
                  {/*footer*/}
                  <button
                    className="flex justify-center gap-2 items-center py-3 mb-4 mx-6 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear bg-primary rounded-xl shadow outline-none  hover:shadow-lg focus:outline-none"
                    type="button"
                    onClick={() => {
                      setShowServiceModal(false);
                      isAuth
                        ? setShowServiceContactModal(true)
                        : navigator("/login");
                    }}
                  >
                    <div>طلب</div>
                    {circle_add}
                  </button>
                </div>
              </div>
            </div>
            <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"></div>
          </>
        ) : null}
      </div>
      {showServiceContactModal && (
        <ContactModal
          offer={service}
          setShowContactModal={setShowServiceContactModal}
        />
      )}

      {myOffers?.services?.filter((e) => e.status !== "sold").length === 0 ||
      myOffers?.services?.length === 0 ? (
        <div className="flex flex-col h-72 -span-2 mt-10 justify-center items-center text-center lg:col-span-5">
          <div>
            <img src={empty_box} alt=""></img>
          </div>
          <div className="font-bold mt-3">لا توجد مدخلات</div>
          <div className="h-10"></div>
        </div>
      ) : (
        <div className="flex flex-wrap gap-3 flex-row-reverse">
          {myOffers?.services
            ?.filter((e) => e.status !== "sold")
            .map((item) => (
              <div
                className=" relative flex flex-row-reverse lg:flex-col items-center justify-evenly overflow-hidden w-full bg-white border-2 border-primary rounded-2xl  h-[8rem] lg:w-[13rem] lg:min-w-[13rem] lg:h-72 min-w-full lg:text-2xl"
                key={item.id}
                onClick={() => getService(item.id)}
              >
                <img
                  src={item.service.image}
                  className=" w-[80px] lg:h-[6rem] lg:w-auto   max-h-[80px]"
                  alt=""
                />
                <div className="flex w-[160px] gap-2 lg:w-auto flex-col text-right  lg:mx-auto lg:font-normal pr-2 lg:p-0 lg:text-center">
                  <div className="font-bold text-lg mb-2 lg:mb-4">
                    {item.service.name}
                  </div>
                  <div className="text-sm font-bold">{item._state.name}</div>
                </div>

                <div className="lg:absolute lg:inset-3 lg:gap-52 flex flex-col gap-6   mb-2  ">
                  {isAuth &&
                    item.owner === localStorage.getItem("user_id") &&
                    (item.service_type === "supply" ? (
                      <Link to={`/editService/${item.id}`}>
                        <div className=" font-bold">{edit_icon}</div>
                      </Link>
                    ) : (
                      <Link to={`/editServiceOrder/${item.id}`}>
                        <div className=" font-bold">{edit_icon}</div>
                      </Link>
                    ))}
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      setItem(item);
                      setDetailsModal(true);
                    }}
                    className="lg:ml-auto   cursor-pointer"
                  >
                    {delete_icon}
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default ServicesInputs;

const ModalTable = ({ description, value }) => {
  return (
    <div className="flex gap-4">
      <div className="flex">
        <div className=" text-sm w-[80px] leading-relaxed font-bold">
          {description}
        </div>
        <div className="text-black font-bold">:</div>
      </div>

      <div className="text-sm leading-relaxed font-bold ">{value}</div>
    </div>
  );
};
